module.exports = __webpack_public_path__ + "public/img/monitorBg.bdca5fe2.png";